import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useRef } from "react";
import { exchangeSession } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match?.[1];

    if (!session_id) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const data = await exchangeSession(session_id);
        // clear the hash immediately so back-nav doesn't retrigger
        window.history.replaceState(null, "", "/dashboard");
        await refresh();
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        console.error("Auth exchange failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F1115]">
      <div className="text-center" data-testid="auth-callback-loader">
        <div className="pp-label mb-3">Signing you in</div>
        <div className="font-display text-2xl text-white">
          Verifying your credentials…
        </div>
      </div>
    </div>
  );
}
